import { PanelBody, RangeControl } from '@wordpress/components';
import { PanelColorSettings } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function StyleControls( { attributes, setAttributes } ) {
	return (
		<PanelBody
			title={ __( 'Style', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Line width', 'brandy-blocks' ) }
				value={ attributes.lineWidth }
				onChange={ ( v ) => setAttributes( { lineWidth: v } ) }
				min={ 1 }
				max={ 10 }
			/>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Marker size', 'brandy-blocks' ) }
				value={ attributes.markerSize }
				onChange={ ( v ) => setAttributes( { markerSize: v } ) }
				min={ 8 }
				max={ 40 }
			/>
			<PanelColorSettings
				title={ __( 'Colors', 'brandy-blocks' ) }
				initialOpen={ false }
				disableCustomColors={ false }
				colorSettings={ [
					{
						value: attributes.lineColor,
						onChange: ( v ) =>
							setAttributes( { lineColor: v } ),
						label: __( 'Line', 'brandy-blocks' ),
					},
					{
						value: attributes.markerColor,
						onChange: ( v ) =>
							setAttributes( { markerColor: v } ),
						label: __( 'Marker', 'brandy-blocks' ),
					},
					{
						value: attributes.markerBgColor,
						onChange: ( v ) =>
							setAttributes( { markerBgColor: v } ),
						label: __( 'Marker background', 'brandy-blocks' ),
					},
				] }
			/>
		</PanelBody>
	);
}
